/** @format */

import { PROD } from "./utils/constants";

export const environment = {
  API: `${process.env.REACT_APP_API}`,
  APIforS3: `${process.env.REACT_APP_APIFORS3}`,
  orgUrl: `${process.env.REACT_APP_ORG_URL}`,
  issuerId: `${process.env.REACT_APP_ISSUERID}`,
  client_id: `${process.env.REACT_APP_CLIENT_ID}`,
  cargill_id: `${process.env.REACT_APP_CARGILL_ID}`,
  implicit_callback: `${process.env.REACT_APP_IMPLICIT_CALLBACK}`,
  redirect_uri: `${window.location.origin}${process.env.REACT_APP_REDIRECT_URI}`,
  organisation_uri: `${window.location.origin}${process.env.REACT_APP_ORGANISATION_URI}`,
  app_redirect_uri: `${process.env.REACT_APP_REDIRECT_URI}`,
  app_env: `${process.env.REACT_APP_ENV}`,
  idp_id : `${process.env.REACT_APP_CARGILL_ID}`,
  google_recaptch_sitekey: `${process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}`,
  api_key : `${process.env.REACT_APP_BAR_CHART_API_KEY}`,
  C3_api_key : `${process.env.REACT_APP_C3_BAR_CHART_API_KEY}`,
  dd_site: 'datadoghq.com',
  dd_service: 'marketintelligence'
};

const ISSUER = `${environment.orgUrl}oauth2/${environment.issuerId}`;

let USE_INTERACTION_CODE = false;
if (process.env.USE_INTERACTION_CODE === "true") {
  USE_INTERACTION_CODE = true;
}

export const config = {
  oidc: {
    issuer: ISSUER,
    clientId: environment.client_id,
    redirectUri: environment.redirect_uri,
    scopes: ["openid", "profile", "email", "address", "phone", "offline_access"],
    postLogoutRedirectUri: environment.app_env === PROD ? `${window.location.origin}/LogIn` : undefined,
    tokenManager: {
      autoRenew: true,
    },
    services: {
      autoRenew: true,
    },
    pkce: true,
  },
  widget: {
    issuer: ISSUER,
    clientId: environment.client_id,
    redirectUri: environment.redirect_uri,
    scopes: ["openid", "profile", "email", "address", "phone", "offline_access"],
    useInteractionCodeFlow: USE_INTERACTION_CODE,
    authParams: {
      pkce: true,
    },
    idps: [{
      id: environment.idp_id,
      text: "Cargill Employees Sign In",
      type: "MICROSOFT",
      className: "btn-customAuth default-custom-button"
    }]
  },
  appRedirectUri: environment.app_redirect_uri,
  appOrgUrl: environment.orgUrl,
  cargillFederationId: environment.cargill_id,
};
